<template>
  <div>
    <form data-vv-scope="data-user">
      <div class="row mb-5">
        <div class="col-12 mt-3" v-if="leader && leader.nombre">
          <b>Líder Actual:</b> {{leader.nombre}}
        </div>
        <div class="col-12 mt-3" v-if="!leader.nombre">
          <b>Este grupo no tiene líder</b>
        </div>
        <div class="col-12 mt-3">
          <list-group-users
            class="w-100"
            autocomplete
            label="Usuarios"
            name="user"
            :parent-value="group.id"
            ref="resendName"
            v-model="process.user"
            :danger="errors.has('data-user.user')"
            :danger-text="errors.first('data-user.user')"
            v-validate="'required'"
          />
        </div>
      </div>
      <div class="chip-custom">
        Al cambiar de líder, se reemplazará al actual y todos los procesos que estén
        pendientes serán traspasados a éste nuevo líder.
      </div>
      <div v-if="error.message !== ''" class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to text-right"
           style="height: 32px;">
          <span class="span-text-validation">
            {{error.message}}
          </span>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <b-button
          variant="outline-primary"
          @click="saveChanges"
        >
          Guardar
        </b-button>
      </div>
    </form>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import ListGroupUsers from '@/febos/chile/lists/components/ListGroupUsers';

export default {
  mixins: [],
  components: {
    ListGroupUsers
  },
  data() {
    return {
      error: {
        message: ''
      },
      process: {
        user: ''
      },
      updateGroup: {},
      leader: {}
    };
  },
  watch: {
    process(newValue) {
      this.process = newValue;
    },
    group(newValue) {
      this.updateGroup = this.groupsCompany.find((group) => group.id === newValue.id);
    },
    usersByGroup(newValue) {
      this.leader = (newValue || []).find((user) => user.esLider === 'Y') || {};
    }
  },
  props: {
    group: Object
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'groupsCompany',
      'usersByGroup'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  methods: {
    ...mapActions('Empresas', [
      'markLiderInGroup'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-user');
      if (!isValid) {
        return;
      }

      this.error.message = '';

      const isUser = this.process.user === this.leader.id;

      if (isUser) {
        this.$bvToast.toast(
          'No puedes seleccionar el mismo usuario que ya es líder',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      const body = {
        grupoId: this.group.id,
        usuarioId: this.process.user,
        reemplazoId: this.leader.id || '',
        esLider: 'Y'
      };

      await this.markLiderInGroup({ empresaId: this.company.id, body });
      this.$emit('close-action');
    },
    cancelEdit() {}
  },
  created() {
    this.leader = (this.usersByGroup || []).find((user) => user.esLider === 'Y') || {};
  }
};
</script>
<style scoped>
.chip-custom {
  font-size: 12px;
  margin-top: 10px;
  color: #ffb300;
  background: #fff5df;
  border-radius: 10px;
  padding: 4px 8px;
}
</style>
